import { useMemo } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { required } from 'libs/form';
import { StyledField, ErrorMsg, Submit } from './auth.v2.styled';

const Form = ({ error, handleSubmit, submitting, valid, opened }) => {
  const { t } = useTranslation();

  const requiredInputs = useMemo(() => [required(t)], [t]);

  const getErrorMessage = () => {
    switch (error) {
      case 'Invalid params: user not found':
      case 'User not found':
      case 'Invalid password':
        return t('errors.invalidPassword');
      case 'User is blocked':
        return t('errors.userIsBlocked');
      default:
        return t('errors.loginError');
    }
  };

  const tlogin = t('form.login');
  const tpassword = t('form.password');
  const tloginbtn = t('form.loginBtn');

  return (
    <form onSubmit={handleSubmit}>
      {error ? (
        <ErrorMsg>
          <img src="/images/error-triangle-icon.png" alt="" width="16" height="16" />
          {getErrorMessage()}
        </ErrorMsg>
      ) : null}
      <StyledField type="text" label={tlogin} name="username" placeholder={tlogin} error={error} withoutWrapper validate={requiredInputs} />
      <StyledField type="password" label={tpassword} name="password" placeholder="••••••••" error={error} withoutWrapper validate={requiredInputs} />
      <Submit disabled={!valid || submitting} $opened={opened}>
        {opened ? /*t('form.barrierOpen')*/ '...' : tloginbtn}
      </Submit>
    </form>
  );
};

export const LoginFormV2 = reduxForm({ form: 'auth' })(Form);
